import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthButton } from '../../auth/auth-button/auth-button';
import { SiteName } from '../../common/site-name/site-name';

@Component({
  selector: 'header[app-account-header]',
  imports: [SiteName, RouterModule, AuthButton],
  templateUrl: './account-header.html',
  styleUrl: './account-header.scss',
})
export class AccountHeader { }
